import styled from "styled-components/macro";

export const ReportStyles = styled.div`
  float: none;

  .reportContent {
    @media print {
      display: none !important;
    }
  }

  .reportPrintContent {
    display: none;
  }

  .invisible-header {
    display: none;
    @media print {
      display: inline !important;
    }
  }

  @media print {
    @page {
      size: landscape !important;
      margin: 0mm;
    }

    .reportPrintContent {
      display: inline;
    }

    .invisible-header {
      break-before: all;
      display: initial;
    }

    .chartBreakLineRow {
      break-after: all;
    }
  }
`;
